import {ErrorHandler, NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {HttpClientModule} from '@angular/common/http'
import {SharedModule} from './shared/shared.module'
import {StoreModule} from '@ngrx/store'
import {StoreDevtoolsModule} from '@ngrx/store-devtools'
import {routerReducer, StoreRouterConnectingModule} from '@ngrx/router-store'
import {environment} from '../environments/environment.prod'
import {EffectsModule} from '@ngrx/effects'
import {Features} from './shared/store/features'
import {InitEffects} from './init/store/init.effects'
import {samoobslugaReducers} from './shared/store/samoobsluga/samoobsluga.reducers'
import {ErrorComponent} from './shared/error/error.component'
import {GlobalErrorHandler} from './shared/error/global-error.handler'
import {ErrorsEffect} from './shared/store/errors/errors.effect'
import {errorsReducers} from './shared/store/errors/errors.reducers'
import {ErrorUiComponent} from './shared/error/ui/error-ui/error-ui.component'
import {EffectUtil} from './shared/store/effect-util'
import {NavigationService} from './shared/services/navigation/navigation.service'
import {UuidGeneratorService} from './shared/services/id-generator/uuid-generator.service'
import {CustomSerializer} from './shared/store/router/router-serializer'
import {InterceptorsModule} from './shared/interceptors/interceptors.module'
import {InitComponent} from './init/init.component'
import {SamoobslugaService} from './shared/services/samoobsluga/samoobsluga.service'
import {daneKlientaReducer} from './shared/store/samoobsluga/daneKlienta/daneKlienta.reducers';
import {przedmiotyReducer} from './shared/store/samoobsluga/przedmioty/przedmioty.reducers';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PersistStoreEffects} from './shared/store/persistence/persist-store.effects'
import {restoreStoreState} from './shared/store/persistence/persist-store.meta-reducers';
import {SamoobslugaEffects} from './shared/store/samoobsluga/samoobsluga.effects';
import {InitGuard} from './shared/services/navigation/guards/init-guard';
import {zbiorUszkodzenReducer} from './shared/store/zbior-uszkodzen/zbiorUszkodzen.reducers';
import {
  zbiorUszkodzenPrzedmiotowReducer
} from './shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow.reducers';
import {ZbiorUszkodzenEffects} from './shared/store/zbior-uszkodzen/zbiorUszkodzen.effects';
import {
  ZbiorUszkodzenPrzedmiotowEffects
} from './shared/store/zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotow.effects';
import {parametryBiznesoweReducer} from './shared/store/parametry/parametryBiznesowe.reducers';
import {TenantService} from './shared/services/tenant/tenant.service';
import {
  parametryKwotyDocelowejReducer
} from './shared/store/samoobsluga/parametryKwotyDocelowej/parametryKwotyDocelowej.reducers';
import {historiaNawigacjiReducer} from './shared/store/historia-nawigacji/historia-nawigacji.reducer';
import '@angular/common/locales/global/pl';
import {PakTenantService} from './shared/services/pak/pak-tenant.service';
import {EkranKoncowyEffects} from './shared/components/ekran-koncowy/store/ekran-koncowy.effects';
import {infoReducers} from './shared/store/info/info.reducers';
import {InfoService} from './shared/services/info/info.service';
import {LoggingService} from './shared/services/logging/logging.service';
import {togglesReducer} from './shared/store/toggles/toggles.reducers';
import {CookiedlgDirective} from "./consentmanager/cookiedlg.directive";

const ngRxModules: any = [
  StoreModule.forRoot({}, {metaReducers: [restoreStoreState]}),
  StoreModule.forFeature(Features.ROUTER, routerReducer),
  StoreModule.forFeature(Features.SAMOOBSLUGA, samoobslugaReducers),
  StoreModule.forFeature(Features.ERRORS, errorsReducers),
  StoreModule.forFeature(Features.DANE_KLIENTA, daneKlientaReducer),
  StoreModule.forFeature(Features.PRZEDMIOTY, przedmiotyReducer),
  StoreModule.forFeature(Features.PARAMETRY_KWOTY_DOCELOWEJ, parametryKwotyDocelowejReducer),
  StoreModule.forFeature(Features.ZBIOR_USZKODZEN, zbiorUszkodzenReducer),
  StoreModule.forFeature(Features.ZBIOR_USZKODZEN_PRZEDMIOTOW, zbiorUszkodzenPrzedmiotowReducer),
  StoreModule.forFeature(Features.PARAMETRY_BIZNESOWE, parametryBiznesoweReducer),
  StoreModule.forFeature(Features.HISTORIA_NAWIGACJI, historiaNawigacjiReducer),
  StoreModule.forFeature(Features.INFO, infoReducers),
  StoreModule.forFeature(Features.TOGGLES, togglesReducer),
  EffectsModule.forRoot([PersistStoreEffects]),
  EffectsModule.forFeature([
    InitEffects,
    SamoobslugaEffects,
    ErrorsEffect,
    ZbiorUszkodzenEffects,
    ZbiorUszkodzenPrzedmiotowEffects,
    EkranKoncowyEffects
  ]),
  StoreDevtoolsModule.instrument({
    maxAge: 25,
    logOnly: environment.production
  }),
  StoreRouterConnectingModule.forRoot({serializer: CustomSerializer}),
]

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    ErrorUiComponent,
    InitComponent,
    CookiedlgDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    InterceptorsModule,
    ...ngRxModules,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    SamoobslugaService,
    EffectUtil,
    NavigationService,
    UuidGeneratorService,
    InitGuard,
    TenantService,
    PakTenantService,
    InfoService,
    LoggingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
